import React from 'react';
import { useSelector } from 'react-redux';
import { InstallationThresholdText } from '../../utils/constants';
import { configSelector } from '../../selectors/config/configSelector';

import {
  totalProjectPrice,
} from '../../selectors/pricing';

import { InstallationText } from './styles';

export function InstallationThreshold() {
  const total = useSelector(totalProjectPrice);
  const { installationThresholdValue } = useSelector(configSelector);
  const show = total > 0 && total <= installationThresholdValue;
  return (
    <>
      {show && (
        <InstallationText>
          {InstallationThresholdText(installationThresholdValue)}
        </InstallationText>
      )}
    </>
  );
}
